import {
    faAd,
    faAlignCenter,
    faAlignJustify,
    faCalendar,
    faCalendarCheck,
    faCamera,
    faCameraRetro,
    faCartPlus,
    faChartArea,
    faCheck,
    faCheckSquare,
    faClock,
    faClone,
    faCloud,
    faCode,
    faCoins,
    faComment,
    faComments,
    faCrosshairs,
    faCubes,
    faDatabase,
    faDesktop,
    faDotCircle,
    faEye,
    faFingerprint,
    faFont,
    faHourglassHalf,
    faImage,
    faKeyboard,
    faLayerGroup,
    faLightbulb,
    faListOl,
    faMapPin,
    faMousePointer,
    faMusic,
    faPaperPlane,
    faPen,
    faPlug,
    faPuzzlePiece,
    faQrcode,
    faRss,
    faRssSquare,
    faSliders,
    faSort,
    faSpinner,
    faStream,
    faSun,
    faTable,
    faTag,
    faTextWidth,
    faToggleOn,
    faTrowelBricks,
    faUser,
    faVideo,
    faWifi
} from "@fortawesome/free-solid-svg-icons";
import {fa500px, faPix, faChrome, faDigg, faDropbox, faEtsy, faFacebook, faFlickr, faGooglePlus, faHtml5, faInstagram, faLinkedin, faPinterest, faReddit, faTelegram, faTiktok, faTumblr, faTwitter, faYelp, faYoutube} from "@fortawesome/free-brands-svg-icons";
import {SceneMimeTypes} from "../containers/editor/scene-blocks/mime-constants";

export interface IFontIcon {
    icon: any;
    name: string;
}

export const getFontIcons = (even): IFontIcon => {
    switch (even.$.id) {
        case 'param object':
            return {icon: faCode, name: 'param object'};
        case 'param list':
            return {icon: faClone, name: 'param list'};
        case 'player':
            return {icon: faDesktop, name: 'Desktop'};
        case 'facebook':
        case '6300':
            return {icon: faFacebook, name: 'Facebook'};
        case '6305':
        case '4400':
        case '12020':
        case SceneMimeTypes.Facebook:
        case SceneMimeTypes.FacebookGroups:
        case SceneMimeTypes.FacebookVideo:
        case SceneMimeTypes.FacebookWall:
        case SceneMimeTypes.FacebookAlbum:
            return {icon: faFacebook, name: 'Facebook Groups'};
        case '6310':
        case SceneMimeTypes.GoogleBusiness:
            return {icon: faGooglePlus, name: 'Google Business Profile'};
        case '6315':
        case SceneMimeTypes.Instagram:
            return {icon: faInstagram, name: 'Instagram business'};
        case '6320':
        case SceneMimeTypes.LinkedIn:
            return {icon: faLinkedin, name: 'LinkedIn'};
        case '6325':
        case SceneMimeTypes.Pinterest:
            return {icon: faPinterest, name: 'Pinterest'};
        case '6330':
        case SceneMimeTypes.Reddit:
            return {icon: faReddit, name: 'Reddit'};
        case '6335':
        case SceneMimeTypes.Telegram:
            return {icon: faTelegram, name: 'Telegram'};
        case '6340':
        case SceneMimeTypes.TikTok:
            return {icon: faTiktok, name: 'Tiktok'};
        case SceneMimeTypes.X:
        case 'X':
        case '6345':
            return {icon: faTwitter, name: 'X'};
        case '6350':
        case SceneMimeTypes.YouTube:
            return {icon: faYoutube, name: 'YouTube'};
        case '3130':
            return {icon: faPuzzlePiece, name: 'Image resource'};
        case '3140':
            return {icon: faPuzzlePiece, name: 'SVG resource'};
        case '3145':
            return {icon: faMusic, name: 'Music'};
        case '4110':
            return {icon: faMusic, name: 'Music-list'};
        case 'mainPlayer':
        case '4102':
            return {icon: faCubes, name: 'Playlist'};
        case '4101':
            return {icon: faFingerprint, name: 'Swiper'};
        case '4103':
            return {icon: faSpinner, name: 'Loader'};
        case '4104':
            return {icon: faCalendarCheck, name: 'Scheduler'};
        case '4120':
            return {icon: faTrowelBricks, name: 'HourlyBalancer'};
        case '4100':
            return {icon: faStream, name: 'Collection'};
        case '10005':
            return {icon: faCubes, name: 'Embedded'};
        case 'flickr':
        case 'Flickr':
        case SceneMimeTypes.Flickr:
        case '6220':
            return {icon: faFlickr, name: 'Flickr'};
        case '3510':
        case '10010':
            return {icon: faCrosshairs, name: 'Scene'};
        case '7060':
            return {icon: faSliders, name: 'Slider'};
        case '6100':
            return {icon: faUser, name: 'FasterQ'};
        case '7000':
            return {icon: faMousePointer, name: 'Button'};
        case '8000':
            return {icon: faKeyboard, name: 'Keyboard'};
        case '7030':
            return {icon: faDotCircle, name: 'Radio'};
        case '4330':
            return {icon: faCartPlus, name: 'Cart'};
        case '7010':
            return {icon: faCheckSquare, name: 'Checkbox'};
        case '7040':
            return {icon: faToggleOn, name: 'Switch'};
        case '7020':
            return {icon: faSort, name: 'Stepper'};
        case '3420':
            return {icon: faAd, name: 'AdNet'};
        case '3600':
            return {icon: faListOl, name: 'Form'};
        case '7050':
            return {icon: faFont, name: 'Input'};
        case 'scene':
            return {icon: faCrosshairs, name: 'Scene'};
        case '10020':
            return {icon: faPaperPlane, name: 'Ext Resource'};
        case '3242':
            return {icon: faTextWidth, name: 'LabelQueue'};
        case '3241':
        case '10030':
            return {icon: faPen, name: 'Label'};
        case '4300':
            return {icon: faPuzzlePiece, name: 'Json Player'};
        // case SceneMimeTypes.NetFeedNews:
        // case '4300.1':
        //     return {icon: faNewspaper, name: 'NetFeed News'};
        // case SceneMimeTypes.NetFeedHoroscope:
        // case '4300.2':
        //     return {icon: faScaleBalanced, name: 'NetFeed Horoscope'};
        case '4305':
            return {icon: faPuzzlePiece, name: 'Json Viewer'};
        case '3235':
        case '10040':
            return {icon: faHtml5, name: 'HTML'};
        case '3345':
        case '10050':
            return {icon: faRss, name: 'RSS'};
        case '3340':
            return {icon: faWifi, name: 'Podcast'};
        case SceneMimeTypes.Catalog:
        case 'Catalog':
        case '10100':
        case '3280':
            return {icon: faDatabase, name: 'Catalog'};
        case SceneMimeTypes.CustomRss:
        case 'CustomRss':
        case '10060':
        case '3346':
            return {icon: faRssSquare, name: 'Custom RSS'};
        case SceneMimeTypes.XML:
        case 'Xml':
        case 'XML':
        case '4200':
            return {icon: faCode, name: 'XML'};
        case '3100':
            return {icon: faVideo, name: 'Video resource'};
        case '10070':
        case '3150':
            return {icon: faVideo, name: 'Linked Video'};
        case '6010':
        case '10080':
        case SceneMimeTypes.Weather:
            return {icon: faSun, name: 'Weather'};
        case SceneMimeTypes.Stocks:
        case 'Stocks':
        case '10090':
        case '3338':
            return {icon: faChartArea, name: 'Stocks'};
        case '3160':
            return {icon: faImage, name: 'Linked Image'};
        case '10110':
        case '3410':
            return {icon: faLayerGroup, name: 'External / Camera'};
        case '3320':
        case '10120':
            return {icon: faClock, name: 'Clock'};
        case '3322':
        case '10122':
            return {icon: faHourglassHalf, name: 'Countdown'};
        case '10130':
            return {icon: faChartArea, name: 'Chart'};
        case '10140':
            return {icon: faPuzzlePiece, name: 'External app'};
        case '10145':
            return {icon: faCamera, name: 'WebKit'};
        case '10150':
            return {icon: faTag, name: 'Adnet'};
        case '3430':
        case '10160':
            return {icon: faQrcode, name: 'QR Code'};
        case '10180':
            return {icon: faAlignJustify, name: 'Collection'};
        case '4105':
        case '10185':
            return {icon: faMapPin, name: 'Location'};
        case SceneMimeTypes.IFTTT:
        case '10190':
        case '6500':
            return {icon: faLightbulb, name: 'IFTTT'};
        case '10195':
            return {icon: faPlug, name: 'JSON'};
        case '10210':
        case '6230':
            return {icon: faTwitter, name: 'Twitter'};
        case '10220':
        case '4600':
            return {icon: faYoutube, name: 'YouTube'};
        case '10300':
            return {icon: faCheck, name: 'Form'};
        case '10400':
            return {icon: faComment, name: 'Message'};
        case '10500':
            return {icon: faAlignCenter, name: 'Label Queue'};
        case '5500':
        case '11000':
            return {icon: faChrome, name: 'Browser'};
        case '12000':
            return {icon: faDigg, name: 'Digg'};
        case '12010':
            return {icon: faCloud, name: 'World weather'};
        case SceneMimeTypes.EtsyShop:
        case SceneMimeTypes.EtsyProfile:
        case SceneMimeTypes.EtsyListing:
        case '6250':
            return {icon: faEtsy, name: 'Etsy'};
        case SceneMimeTypes.PinterestUser:
        case SceneMimeTypes.PinterestBoard:
        case '6080':
            return {icon: faPinterest, name: 'Pinterest'};
        case '12030':
        case '6020':
        case SceneMimeTypes.Calendar:
            return {icon: faCalendar, name: 'Calendar'};
        case '6022':
        case '12032':
        case SceneMimeTypes.Spreadsheet:
            return {icon: faTable, name: 'Spreadsheet'};
        case '12040':
            return {icon: faGooglePlus, name: 'Plus'};
        case '12050':
            return {icon: faEye, name: 'Picasa'};
        case SceneMimeTypes.FiveHundredUser:
        case SceneMimeTypes.FiveHundredCollection:
        case '6070':
            return {icon: fa500px, name: '500px'};
        case '6050':
        case '12060':
        case SceneMimeTypes.InstagramMedia:
        case SceneMimeTypes.InstagramFeed:
            return {icon: faInstagram, name: 'Instagram'};
        case '6090':
        case SceneMimeTypes.TumblrTexts:
        case SceneMimeTypes.TumblrPhotos:
        case SceneMimeTypes.TumblrVideos:
        case SceneMimeTypes.TumblrPosts:
            return {icon: faTumblr, name: 'Tumblr'};
        case '6240':
        case SceneMimeTypes.YelpInfo:
        case SceneMimeTypes.YelpReviews:
            return {icon: faYelp, name: 'Yelp'};
        case '12070':
        case '6060':
        case SceneMimeTypes.GoogleDrive:
            return {icon: faGooglePlus, name: 'Drive'};
        case '12080':
            return {icon: fa500px, name: '500px'};
        case '12090':
            return {icon: faPinterest, name: 'Pinterest'};
        case '12100':
            return {icon: faCamera, name: 'FasterQ'};
        case '12200':
            return {icon: faTumblr, name: 'Tumblr'};
        case SceneMimeTypes.DropBox:
        case 'Dropbox':
        case '12210':
        case '6210':
            return {icon: faDropbox, name: 'Dropbox'};
        case '12220':
            return {icon: faFlickr, name: 'Flickr'};
        case '12230':
        case SceneMimeTypes.Twitter:
            return {icon: faTwitter, name: 'Twitter'};
        case '12240':
            return {icon: faYelp, name: 'Yelp'};
        case '12250':
            return {icon: faEtsy, name: 'Etsy'};
        case '12260':
            return {icon: faClone, name: 'Mashape'};
        case '5010':
            return {icon: faClone, name: 'KNX'};
        case '5000':
            return {icon: faClone, name: 'Serial Port'};
        case '3245':
            return {icon: faComments, name: 'Chat'};
        case '3350':
            return {icon: faCameraRetro, name: 'Webcam'};
        case '4310':
        case '3270':
        case '3335':
        case '4210':
        case '3348':
            return {icon: faCoins, name: 'Item'};
        case '5600':
            return {icon: faPix, name: 'Canva'};
        default: {
            return {icon: faCrosshairs, name: 'Player'};
        }
    }
};
